/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.RatingsControlPanel {

    class ReplyModalController {
        static $inject = [
            '$mdDialog',
            'meevo.components.short-cuts.ShortCutsService'
        ];

        public employeeLastName: string;
        public employeeFirstName: string;
        public serviceShortcut: string;
        public serviceDisplayName: string;
        public comment: string;
        public replyModel: string;

        private shortCutGroup: IShortCutGroup;

        constructor(private $mdDialog: ng.material.IDialogService,
                    private shortCutsService: Meevo.Components.ShortCuts.IShortCutsService) {
            this.configureShortCuts();
        }

        public closeModal(): void {
            this.$mdDialog.cancel();
            this.shortCutsService.deactivateGroup(this.shortCutGroup);
        }

        public save(): void {
            this.$mdDialog.hide(this.replyModel || null);
            this.shortCutsService.deactivateGroup(this.shortCutGroup);
        }

        private configureShortCuts() {
            this.shortCutGroup = new ShortCutGroup([
                {
                    shortCutName: 'MODAL_SAVE_BUTTON',
                    callback: () => {
                        this.save();
                    }
                },
                {
                    shortCutName: 'MODAL_CANCEL_BUTTON',
                    callback: (event: Event, hotkey: ng.hotkeys.Hotkey) => {
                        event.preventDefault();

                        this.closeModal();
                    }
                }
            ], {
                groupLevel: Components.ShortCuts.GroupLevels.Modal,
                deactivateGlobal: true,
            });
        }
    }

    angular.module('meevo.plugins.ratingsControlPanel')
        .controller('meevo.plugins.ratingsControlPanel.ReplyModalController', ReplyModalController);
}
